import React from 'react';
import './components.css'
import photo from '../data/gallery.jpg'
import kai from '../data/kai.jpg'
import coffee from '../data/coffee.jpg'
import bakery from '../data/bakery.jpg'
import grad from '../data/grad.jpg'
import arrow from '../data/stickers/arrow.png'
import blueBowTape from '../data/stickers/blue_bow_tape.png'
import cowTape from '../data/stickers/cow_tape.png'
import lavenderStarTape from '../data/stickers/lavender_star_tape.png'
import pinkGinghamTape from '../data/stickers/pink_gingham_tape.png'
import polkaTape from '../data/stickers/polka_tape.png'
import pinkBow from '../data/stickers/pink_bow.png'
import yellowGinghamStar from '../data/stickers/yellow_gingham_star.png'

function About() {
    return (
        <>
            <section className='intro' id='about'>
                <h1 className='intro-copy'>
                    Hey there, I’m <span className='name-mark'>Jennifer</span> 💫
                    Welcome to my <span className='garden-mark'>digital notebook</span> 📓
                </h1>
                <p className='intro-copy'>
                    I like designing <span className='em'>interfaces</span>, using <a className='link-sky' href='#publications'>AI</a> to enhance user experience, and making <a className='link-orange' href='#projects'>pretty graphs</a> that help people understand data.
                    I’m a <span className='role-mark'>Lead Research Scientist</span> in Visual Analytics and UI/UX at <span className='em'>Epsilon</span> in Chicago.
                </p>
                <div className='intro-washu'>
                    <p className='intro-copy'>
                        Before that, I did my Ph.D. in Computer Science at WashU, focused on visual analytics, with <a className='link-lime' href="https://engineering.wustl.edu/faculty/Alvitta-Ottley.html" target="_blank" rel="noopener noreferrer">Alvitta Ottley</a> in the
                        <br />
                        <a className='link-sky' href="http://visualdata.wustl.edu/" target="_blank" rel="noopener noreferrer">VIBE Lab</a>.
                    </p>
                    <figure className='photo-tile photo-grad'>
                        <div className='photo-frame'>
                            <img className='garden-photo grad-photo' src={grad} alt="Graduation day at WashU, in doctoral regalia with a bouquet" />
                            <p className='photo-caption'>Graduation day! 🎓</p>
                        </div>
                        <img className='sticker-arrow-washu' src={arrow} alt="" aria-hidden="true" />
                        <img className='photo-sticker sticker-tape-grad' src={lavenderStarTape} alt="" aria-hidden="true" />
                    </figure>
                </div>
                <p className='intro-copy last'>
                    Outside of work, I enjoy long walks with my dog <a className='link-lilac' href='#kai'>Kai</a> 🐕 and exploring <a className='link-orange' href='#cafes'>cafes and bakeries</a> around the city 🥐
                </p>
            </section>

            <div className='photo-stack'>
                <figure className='tile photo-tile photo-gallery'>
                <div className='photo-frame'>
                    <img className='garden-photo gallery-photo' src={photo} alt="Looking at a painting at the Guggenheim" />
                    <p className='photo-caption'>At the Guggenheim 🍎</p>
                </div>
                <img className='photo-sticker sticker-tape-gallery' src={blueBowTape} alt="" aria-hidden="true" />
                <img className='photo-sticker sticker-tape-gallery-br' src={pinkGinghamTape} alt="" aria-hidden="true" />
            </figure>

            <figure className='tile photo-tile photo-kai' id='kai'>
                <div className='photo-frame'>
                    <img className='garden-photo kai-photo' src={kai} alt="Kai on a walk, in a purple harness and booties" />
                </div>
                <img className='photo-sticker sticker-star' src={yellowGinghamStar} alt="" aria-hidden="true" />
                <img className='photo-sticker sticker-bow-kai' src={pinkBow} alt="" aria-hidden="true" />
                </figure>
            </div>

            <figure className='tile photo-tile photo-coffee' id='cafes'>
                <div className='photo-frame'>
                    <img className='garden-photo coffee-photo' src={coffee} alt="Two iced coffees on a cafe counter" />
                    <p className='photo-caption'>Can't live without iced coffee ☕</p>
                </div>
                <img className='photo-sticker sticker-tape-coffee' src={cowTape} alt="" aria-hidden="true" />
            </figure>

            <figure className='tile photo-tile photo-bakery'>
                <div className='photo-frame'>
                    <img className='garden-photo bakery-photo' src={bakery} alt="A colorful cafe spread of cakes, fruit sandwiches, and drinks" />
                    <p className='photo-caption'>The cutest fruit sandos 🍓</p>
                </div>
                <img className='photo-sticker sticker-tape-top' src={polkaTape} alt="" aria-hidden="true" />
            </figure>

            <section className='tile now-tile'>
                <h2 className='tile-label'>Now</h2>
                <p className='now-place'>Chicago 📍</p>
                <p className='now-line'>At Epsilon, building a more personalized interface and a conversational agent.</p>
                <p className='now-line muted'>Previously St. Louis, for a Ph.D. in visual analytics.</p>
            </section>
        </>
    )
}

export default About;
